import WaitlistConfirmationPopup from './WaitlistConfirmationPopup';

export default WaitlistConfirmationPopup;
